export const BASE_URL = 'https://demo.api.driveim.com';
export const BASE_URL_DEV = 'https://beta.app.driveim.com';

export const Uris = {
  Account: '/account',
  Attribute: '/attribute',
  Agenda: '/appointment',
  AgendaId: '/appointment/:id',
  Ticket: '/ticket',
  TicketJoin: '/ticket/:id/join',
  TicketJoinChannel: '/ticket/:id/channel/:cid/join',
  TicketAddParticipants: '/ticket/:id/channel/:cid/participant',
  TicketRemoveParticipants: '/ticket/:id/channel/:cid/participant',
  Channel: '/channel',
  TicketDetail: '/ticket/:id',
  TicketChanel: '/ticket/:id/channel/:cid',
  TicketSendMessage: '/ticket/:id/channel/:cid/message',
  TicketSendAttachment: '/ticket/:id/channel/:cid/attachment',
  TicketActionRequestQuote: '/ticket/:id/quote',
  TicketActionRequestMandate: '/ticket/:id/mandate',
  TicketActionClose: '/ticket/:id/close',
  TicketActionReopen: '/ticket/:id/reopen',
  TicketAskAppointment: '/ticket/:id/appointment_action',
  TicketGetAppointments: '/ticket/:id/appointments',
  TicketDeleteAppointment: '/ticket/:id/appointment_action',
  TicketInterventionReport: '/ticket/:id/intervention_report',
  TicketUpdateMessage: '/ticket/:id/channel/:cid/message/:mid',
  TicketUpdateAttachment: '/ticket/:id/channel/:cid/attachment/:aid',
  Notification: '/notification',
  Block: '/block',
  BlockId: '/block/:id',
  BlockIdDashboard: '/block/:id/dashboard',
  BlockApartments: '/block/:id/apartment',
  BlockApartmentId: '/block/:id/apartment/:cid',
  BlockDocuments: '/block/:id/document',
  BlockTenants: '/block/:id/tenant',
  BlockOwners: '/block/:id/owner',
  BlockStatistic: '/block/:id/statistics',
  BlockIdContacts: '/block/:id/contact',
  Apartment: '/apartment',
  ApartmentId: '/apartment/:id',
  Authorization: '/authentication',
  AuthorizationForgot: '/authManagement?apiKey=e230dca46b594277984a2257071c665f',
  ProfileChangeEmail: '/authManagement',
  UserFunctionality: '/functionality',
  User: '/users',
  UserRegister: '/users?apiKey=e230dca46b594277984a2257071c665f',
  Search: '/search',
  SearchId: '/search/:id',
  BlockTenantId: '/block/:id/tenant/:cid',
  BlockOwnerId: '/block/:id/owner/:cid',
  TenantId: '/tenant/:id',
  Home: '/statistics',
  Closure: '/closure_reason',
  TicketReason: '/ticket_reason',
  AttachmentTypes: '/attachment_types',
  AttachmentTypesById: '/attachment_types/:id',
  AttachmentTypesAttribute: '/attachment_types/:id/attribute',
  AttachmentTypesAttributeById: '/attachment_types/:idt/attribute/:ida',
  Media: '/media/:id',
  NotificationEntitySettingList: '/notification_entity_setting',
  NotificationEntitySetting: '/notification_entity_setting/:id',
  Reception: '/reception_process',
  ReceptionById: '/reception_process/:id',
  ReceptionSectionsById: '/reception_process/:id/section',
  ReceptionSectionById: '/reception_process/:id/section/:sid',
  ReceptionTypes: '/receipt_form_items_type',
  CheckBlock: '/check_block?apiKey=e230dca46b594277984a2257071c665f',
  UserRegisterVerify: '/authManagement?apiKey=e230dca46b594277984a2257071c665f',
  AgencyInfoWithoutKey: '/agency_infos',
  AgencyInfo: '/agency_infos/?apiKey=e230dca46b594277984a2257071c665f',
  EntityRoles: '/entity_role',
  CivilityLegalForm: '/civility_legal_form?$limit=50',
  TicketPriority: '/ticket_priority',
  TicketSubstatus: '/ticket_substatus',
  Documents: '/document',
  DocumentTypes: '/my-document',
  DocumentById: '/my-document/:id',
  DocumentsId: '/document/:id',
  DocumentManage: '/manage_document',
  DocumentManageId: '/manage_document/:id',
  BMById: '/bm_master/:id',
  BMMeetingById: '/bm/:id/meeting/:idm',
  BMMeetingPlans: '/bm/:id/meeting/:idm/plan',
  BMMeetingIBComments: '/bm/:id/meeting/:idm/inspection/:idib/comment',
  BMMeetings: '/bm/:id/meeting',
  BM: '/bm_master',
  BMParticipant: '/bm/:id/meeting/:idm/participant/',
  BMParticipantById: '/bm/:id/meeting/:idm/participant/:idp',
  BMIB: '/bm/:id/meeting/:idm/inspection',
  BMIBById: '/bm/:id/meeting/:idm/inspection/:idi',
  BMContractor: '/bm/:id/meeting/:idm/inspection/:idi/contractor',
  BMContractorById: '/bm/:id/meeting/:idm/inspection/:idi/contractor/:idc',
  BMPlan: '/bm/:id/meeting/:idm/plan',
  BMPlanById: '/bm/:id/meeting/:idm/plan/:idp',
  BMComment: '/bm/:id/meeting/:idm/inspection/:idi/comment',
  BMCommentById: '/bm/:id/meeting/:idm/inspection/:idi/comment/:idc',
  BMCommentMedia: '/bm/:id/meeting/:idm/inspection/:idi/comment/:idc/media',
  BMCommentMediaById: '/bm/:id/meeting/:idm/inspection/:idi/comment/:idc/media/:idf',
  BMMeetingBase: '/bm/:id',
  BMBase: '/bm',
  AddMedia: '/add_media',
  BMMarker: '/bm/:id/meeting/:idm/plan/:idp/marker',
  BMMarkerById: '/bm/:id/meeting/:idm/plan/:idp/marker/:idmk',
  Me: '/me',
  Equipment: '/equipment',
  EquipmentById: '/equipment/:id',
  VehicleById: '/vehicule/:id',
  VehicleCost: '/equipment_cost',
  EquipmentAttributeById: '/equipment/:eid/attribute/:aid',
  Vehicule: '/vehicule',
  TicketProblemType: '/ticket_pb_type',
  CharacterProblem: '/character_problem',
  CharacterProblemById: '/character_problem/:id',
  AgencyCharacterProblem: '/agency_character_problem',
  AttributeTypes: '/maint_attribute_type',
  CharPbAttribute: '/character_problem/:idc/attribute',
  CharPbAttributeById: '/character_problem/:idc/attribute/:ida',
  ApartmentZone: '/apartment/:id/zone',
  ApartmentZoneById: '/apartment/:id/zone/:idz',
  ApartmentZoneSearch: '/apartment_zone_search',
  IntervalType: '/maint_interval_type',
  MaintenanceTemplate: '/maintenance_template',
  MaintenanceReport: '/maintenance_report',
  MaintenanceTemplateById: '/maintenance_template/:id',
  Maintenance:'/maintenance',
  MaintenanceById: '/maintenance/:id',
  MaintenanceByIdActions: '/maintenance/:id/action',
  TicketClosingReasons: '/closure_reason',
  TicketReasons: '/ticket_reason',
  ServiceBook: '/service_book',
  ServiceBookProduct: '/service_book_product',
  ServiceBookById: '/service_book/:id',
  TransferServiceBook: '/service_book/:id/transfer',
  ApartmentTypes:'apartment_type',
  DownloadDocument:'/download'
}



// WEBPACK FOOTER //
// ./src/common/constants/uri.constant.ts